// extracted by mini-css-extract-plugin
export default {"button":"GoogleLoginButton_button__pZdtS"};